import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["priorDataAccepted", "priorDataSignature", "priorDataAcceptedDate"];

  connect() {
    this.setTodayIfChecked();
  }

  validate(event) {
    const priorDataAccepted = this.priorDataAcceptedTarget.checked;
    const priorDataSignature = this.priorDataSignatureTarget.value.trim();
    const priorDataAcceptedDate = this.priorDataAcceptedDateTarget.value;

    if (priorDataAccepted) {
      if (!priorDataSignature || !priorDataAcceptedDate) {
        event.preventDefault();
        alert("Please fill all fields before submitting.");
      } else if (priorDataAcceptedDate !== this.todayDate()) {
        event.preventDefault();
        alert(`Accepted date must be today's date: ${this.todayDate()}`);
      }
    } else {
      const confirmation = confirm("Are you sure you want to submit without accepting the prior data?");
      if (!confirmation) {
        event.preventDefault();
      }
    }
  }

  setTodayIfChecked() {
    if (this.priorDataAcceptedTarget.checked) {
      this.priorDataAcceptedDateTarget.value = this.todayDate();
    }
  }

  todayDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
}
